import type { ReactNode } from 'react';
import { useUiLabels } from '../labels';
import { IconButton } from './button';

export interface PaginationProps {
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  /** E.g. "21–40 von 312". */
  summary?: ReactNode;
}

export function Pagination({ page, pageCount, onPageChange, summary }: PaginationProps) {
  const labels = useUiLabels();
  return (
    <div className="flex items-center justify-between gap-3 px-1 py-2 text-xs text-fg-muted">
      <div className="tabular">{summary}</div>
      <div className="flex items-center gap-1">
        <IconButton
          icon="chevron-left"
          label={labels.previousPage}
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        />
        <span className="min-w-12 text-center tabular">
          {page} / {Math.max(pageCount, 1)}
        </span>
        <IconButton
          icon="chevron-right"
          label={labels.nextPage}
          size="sm"
          disabled={page >= pageCount}
          onClick={() => onPageChange(page + 1)}
        />
      </div>
    </div>
  );
}
